import "./MemberLogin3.module.css";
import Header from "@/reusable_sections/Header";
import MemberLogin from "./sections/MemberLogin";
import Partnership from "./sections/Partnership";
import Footer from "@/reusable_sections/Footer";
export default function MemberLogin3Page() {
  return <div>
      <Header />
      <MemberLogin />
      <Partnership />
      <Footer />
    </div>;
}